import api from "./api.js";

export default class GroupApi {
  static async create(data) {
    return await api.post(`api/group`, data);
  }
  static async edit(id, data) {
    return await api.patch(`api/group/${id}`, data);
  }
  static async delete(id, data) {
    return await api.del(`api/group/${id}`, data);
  }

  static async getList(data) {
    return await api.get(`api/group`, data);
  }
  static async getById(id) {
    return await api.get(`api/group/${id}`);
  }
}
